module.exports = __webpack_public_path__ + "img/content2-m.1d92bd6b.png";